import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';
import {DesignServicesModel} from './DesignServicesModel';
import {UnitsModel} from './UnitsModel';
import { LocationModel } from './LocationModel';

export class DeltaVolumiModel {

  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  srv:string;
  region: RegionModel;
  servicesCountry:string;
  billingCountry:string;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  designServices: DesignServicesModel;
  units: UnitsModel;
  delta: number;
  contractType: ContractTypeModel;
  actualMonthVol: number;
  previusMonthVol: number;
  expectedVol: number;
  isDeltaSignificativo: number;
  isClaims: number;
  note: string;
  isRecovery: boolean;
  provider: ProviderModel;
  monthlyForecastQuantity: number;
  applicationCod: string;
  shareName: string;
  location: LocationModel;


  constructor(id?: number,
              numAnnoMeseRif?: number,
              srv?:string,
              region?: RegionModel,
              servicesCountry?: string,
              billingCountry?: string,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              sl1?: DesignServicesModel,
              units?: UnitsModel,
              delta?: number,
              contractType?: ContractTypeModel,
              actualMonthVol?: number,
              previusMonthVol?: number,
              expectedVol?: number,
              note?: string,
              isRecovery?: boolean,
              provider?: ProviderModel,
              monthlyForecastQuantity?: number,
              location?: LocationModel) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.srv = srv;
    this.region = region;
    this.servicesCountry = servicesCountry;
    this.billingCountry = billingCountry;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.designServices = sl1;
    this.units = units;
    this.delta = delta;
    this.contractType = contractType;
    this.actualMonthVol = actualMonthVol;
    this.previusMonthVol = previusMonthVol;
    this.expectedVol = expectedVol;
    this.note = note;
    this.isRecovery = isRecovery;
    this.provider = provider;
    this.monthlyForecastQuantity = monthlyForecastQuantity;
    this.location = location;
  }
}

export class DeltaVolumiStorageModel extends DeltaVolumiModel {
  deltaFilter: number = null;
}

export class DeltaVolumiReportModel extends  DeltaVolumiStorageModel {
  numAnnoMeseFrom: number;
  numAnnoMeseTo: number;
}
